















































































































































































import { Vue, Component, Prop, Watch, PropSync } from "vue-property-decorator";
import { vuex } from "@/store";
import rest from "@/rest";

// Import pdfmake-wrapper and the fonts to use
import { ICreatePDF, PdfMakeWrapper } from 'pdfmake-wrapper';
import * as pdfFonts from "pdfmake/build/vfs_fonts"; // fonts provided for pdfmake
import { Txt, IText } from 'pdfmake-wrapper';
import { Img, IImg } from 'pdfmake-wrapper';

// components
import UserTable from "@/components/UserManagement/UserTable.vue";
import CertificateImportDlg from "@/components/UserManagement/CertificateImportDlg.vue";

// interfaces
import { PortalUserVmClass } from "@/classes/PortalUserVmClass";
import { PortalUserVM } from "@/interfaces/PortalUserVM";
import { GroupVm } from "@/interfaces/GroupVm";
import { UserCertificateVm } from "@/interfaces/UserCertificateVm";
import moment from "moment";
import { ParamDictionary } from "@/interfaces/ParamDictionary";
import { List } from "linq-collections";
import SimpleMessageBox from "../Shared/SimpleMessageBox.vue";

@Component({
  components: {
    SimpleMessageBox,
    CertificateImportDlg
    // EditUser
  }
})
export default class UserDetailsDlg extends Vue {
  @PropSync("showDialog") syncedShowDialog!: boolean;
  @Prop() user!: PortalUserVM;
  panel = [];
  userGroups: GroupVm[] | null = null;
  search: string = "";
  userCertificates: UserCertificateVm[] = [];
  filteredCertificates: UserCertificateVm[] = [];
  selectedCertificate: UserCertificateVm | null = null;
  expandedCertificateIndex: number | null = null;
  focusedCertificateIndex: number | null = null;
  certificateHeaderRefs: Array<HTMLElement | null> = [];
  busy = false;
  showCertificateImportDlg = false;
  showConfirmDeleteCertificate = false;

  // $refs!: {
  // };

  mounted() {
  }

  @Watch("syncedShowDialog")
  async onShowDialog(value: boolean) {
    if (!value) return;
    this.userGroups = null;
    this.search = "";
    this.userCertificates = [];
    this.filteredCertificates = [];

    await this.updateUserGroups();
    await this.updateUserCertificates();
  }

  @Watch("search")
  async onSearch(val) {
    if (!val) {
      this.filteredCertificates = this.userCertificates;
      return;
    }

    const searchValue = val?.toLowerCase() ?? "";
    this.filteredCertificates = new List(this.userCertificates)
      .where(c => {
        const sourceValue = c.bundleName?.toLowerCase() + " " + c.title?.toLowerCase() + " " + c.summary?.toLowerCase();
        return sourceValue.includes(searchValue) ?? false;
      })
      .toArray();
  }

  async updateUserGroups() {
    this.userGroups = await rest.url("orgAdmin/loadUserGroups").post(this.user);
  }

  async updateUserCertificates() {
    this.certificateHeaderRefs = [];
    this.userCertificates = await rest.url("orgAdmin/loadUserCertificates").post(this.user);
    this.filteredCertificates = this.userCertificates;
  }

  certificateTitle(certificate: UserCertificateVm) {
    if (!certificate)
      return "";
    if (certificate.title)
      return certificate.title;
    return certificate.bundleName;
  }

  registerCertificateHeaderRef(el: any, index: number) {
    const actualEl = el && el.$el ? el.$el : el;
    this.certificateHeaderRefs[index] = actualEl as HTMLElement | null;
  }

  focusHeaderAfterToggle(index: number) {
    this.$nextTick(() => {
      const header = this.certificateHeaderRefs[index] as HTMLElement | undefined;
      if (header && typeof header.focus === 'function') {
        this.focusedCertificateIndex = index;
        header.focus();
      }
    });
  }

  onHeaderClick(index: number, event: MouseEvent) {
    const header = (event.currentTarget as HTMLElement | null) || this.certificateHeaderRefs[index] || null;
    if (header && typeof header.focus === 'function') {
      this.focusedCertificateIndex = index;
      header.focus();
    }
    this.focusHeaderAfterToggle(index);
  }

  handlePanelBlur(index: number, event: FocusEvent) {
    const currentPanel = event.currentTarget as HTMLElement | null;

    // Wait for the browser to settle focus before deciding whether to clear highlight.
    this.$nextTick(() => {
      const activeElement = document.activeElement as Node | null;
      if (!currentPanel || !activeElement || !currentPanel.contains(activeElement)) {
        if (this.focusedCertificateIndex === index) {
          this.focusedCertificateIndex = null;
        }
      }
    });
  }

  handleKeyNavigation(event: KeyboardEvent, currentIndex: number) {
    if (!this.filteredCertificates || this.filteredCertificates.length === 0) return;

    let targetIndex = -1;

    switch (event.key) {
      case 'ArrowDown':
      case 'Down':
      case 'ArrowRight':
      case 'Right':
        event.preventDefault();
        targetIndex = currentIndex + 1;
        if (targetIndex >= this.filteredCertificates.length) {
          targetIndex = 0;
        }
        break;

      case 'ArrowUp':
      case 'Up':
      case 'ArrowLeft':
      case 'Left':
        event.preventDefault();
        targetIndex = currentIndex - 1;
        if (targetIndex < 0) {
          targetIndex = this.filteredCertificates.length - 1;
        }
        break;

      case 'Home':
        event.preventDefault();
        targetIndex = 0;
        break;

      case 'End':
        event.preventDefault();
        targetIndex = this.filteredCertificates.length - 1;
        break;

      case ' ':
      case 'Spacebar':
      case 'Space':
        event.preventDefault();
        this.expandedCertificateIndex = this.expandedCertificateIndex === currentIndex ? null : currentIndex;
        this.$nextTick(() => this.focusHeaderAfterToggle(currentIndex));
        return;

      case 'Enter': {
        event.preventDefault();
        const certificate = this.filteredCertificates[currentIndex];
        if (certificate) this.onLoadSingleCertificatePdf(certificate);
        return;
      }

      default:
        return;
    }

    this.focusListItem(targetIndex);
  }

  focusListItem(index: number) {
    this.$nextTick(() => {
      const header = this.certificateHeaderRefs[index] as HTMLElement | undefined;
      if (header && typeof header.focus === 'function') {
        this.focusedCertificateIndex = index;
        header.focus();

        const current = this.filteredCertificates[index];
        const name = current?.bundleName || 'Unbekanntes Zertifikat';
        this.announceToScreenReader(`${name}, Position ${index + 1} von ${this.filteredCertificates.length}`);
      }
    });
  }

  announceToScreenReader(message: string) {
    let announcement = document.getElementById('page-announcements');
    if (!announcement) {
      announcement = document.createElement('div');
      announcement.id = 'page-announcements';
      announcement.setAttribute('aria-live', 'polite');
      announcement.setAttribute('aria-atomic', 'true');
      announcement.className = 'sr-only';
      document.body.appendChild(announcement);
    }

    announcement.textContent = message;
    setTimeout(() => {
      announcement!.textContent = '';
    }, 1200);
  }

  get focusStyle() {
    return {
      '--focus-border-color': this.$store.state.ux.colorAccent,
      '--focus-bg-color': this.$store.state.ux.colorAccent + '10'
    };
  }

  // async onLoadPdf(certificate: UserCertificateVm) {
  //   let pdf = await this.createPdfDocument(certificate);
  //   pdf.create().download(`Zertifikat - ${this.certificateTitle(certificate)}.pdf`);
  // }

  // async onPrintPdf(certificate: UserCertificateVm) {
  //   let pdf = await this.createPdfDocument(certificate);
  //   pdf.create().print();
  // }

  onLoadSingleCertificatePdf(certificate: UserCertificateVm) {
    let params: ParamDictionary = { dictionary: {} };
    params.dictionary!["UserId"] = certificate.userId!;
    params.dictionary!["BundleId"] = certificate.exBundleId.toString() ?? "0";
    params.dictionary!["GroupId"] = "0"; // Will be ignored for Org Admins
    params.dictionary!["PdfFileName"] = certificate.pdfFileName ?? "";

    this.$globalHelper.blobDownloadWithAuth("api/exercises/loadSingleCertificatePdf", `${certificate.firstName} ${certificate.lastName}-${certificate.title ?? certificate.bundleName}-Zertifikat.pdf`, params);
  }

  onLoadCertificatsPdf() {
    let params: ParamDictionary = { dictionary: {} };
    params.dictionary!["userName"] = this.user!.userName!;
    // params.dictionary!["userId"] = this.user!.id!;
    params.dictionary!["startDate"] = "";
    params.dictionary!["endDate"] = "";
    this.$globalHelper.blobDownloadWithAuth("api/orgAdmin/loadUserCertificatesPdf", `${new Date().toISOString().substring(0, 10)}-${this.user.firstName} ${this.user.lastName}-Zertifikate.pdf`, params);
  }

  onConfirmDeletion(certificate: UserCertificateVm) {
    this.selectedCertificate = certificate;
    this.showConfirmDeleteCertificate = true;
  }

  onCertificateImport() {
    this.selectedCertificate = null;
    this.showCertificateImportDlg = true;
  }

  onEditCertificate(certificate: UserCertificateVm) {
    this.selectedCertificate = certificate;
    this.showCertificateImportDlg = true;
  }

  async onDeleteCertificate() {
    this.userCertificates = await rest.url("orgAdmin/deleteUserCertificate").post(this.selectedCertificate);
    this.filteredCertificates = this.userCertificates;
    this.search = "";
  }

  // async createPdfDocument(certificate: UserCertificateVm): Promise<PdfMakeWrapper> {
  //   // Docu: https://pdfmakewrapper.org/docs/getting-started/essential-concepts/main-classes; https://github.com/Lugriz/pdfmake-wrapper
  //   //       https://pdfmakewrapper.org/docs/api-references/document-definition
  //   //       https://github.com/bpampuch/pdfmake; https://pdfmake.github.io/docs/
  //   // vue to pdf: https://github.com/mizuka-wu/vue-pdfmake

  //   // Set the fonts to use
  //   PdfMakeWrapper.setFonts(pdfFonts);

  //   // Define document
  //   const pdf = new PdfMakeWrapper();
  //   pdf.pageSize('A4'); // A4 paper is 595.35 x 841.995 pt. Since A4 is 210 x 297 mm => 1 mm = 2.835 pt
  //   // pdf.pageMargins([ 40, 60, 40, 60 ]);
  //   pdf.info({
  //     title: 'L3RN-online Zertifikat',
  //     subject: this.certificateTitle(certificate) ?? "",
  //     author: 'L3RN-online',
  //   });
  //   let def = pdf.getDefinition();
  //   // console.log("doc definitions:", def);

  //   // Set Background image
  //   const backgroundImage: IImg = await new Img('Zertifikat.png').fit([595.35, 841.995]).build();
  //   pdf.background(backgroundImage);

  //   // User name
  //   // const text = new Txt([
  //   //   new Txt(`${certificate.firstName} ${certificate.lastName}\n\n`).bold().fontSize(24).color("#4089be").end,
  //   //   new Txt("hat die Schulung\n").fontSize(18).color("#494949").end,
  //   //   new Txt(`${{this.certificateTitle(certificate)}\n`).bold().fontSize(24).color("#4089be").end,
  //   //   new Txt(`am ${moment(certificate.closingDate).format("DD.MM.yyyy")}\ erfolgreich absolviert.`).fontSize(18).color("#494949").end,
  //   // ]).alignment("center").lineHeight(1.5).absolutePosition(180,350).end;
  //   // pdf.add(text);

  //   let textArray = [
  //     new Txt(`${certificate.firstName} ${certificate.lastName}\n\n`).bold().fontSize(24).color("#4089be").end,
  //     new Txt("hat die Schulung\n").fontSize(18).color("#494949").end,
  //     new Txt(`${this.certificateTitle(certificate)}\n`).bold().fontSize(24).color("#4089be").end,
  //     new Txt(`am ${moment(certificate.closingDate).format("DD.MM.yyyy")}\ erfolgreich absolviert.`).fontSize(18).color("#494949").end,
  //   ];

  //   if (certificate.comment && certificate.comment.length > 0)
  //     textArray.push(new Txt(`\n\n${certificate.comment}`).fontSize(12).color("#494949").end);

  //   let text = new Txt(textArray).alignment("center").lineHeight(1.5).absolutePosition(180,350).end;
  //   pdf.add(text);

  //   if (certificate.signature && certificate.signature.length > 0) {
  //     const signature = (await new Img(certificate.signature).width(180).absolutePosition(180, 650).build()); //alignment("center").absolutePosition(180, 500);
  //     pdf.add(signature);
  //     let name = new Txt(`${certificate.firstName} ${certificate.lastName}`).fontSize(14).color("#494949").absolutePosition(210, 710).end;
  //     pdf.add(name);
  //   }

  //   // L3RN online
  //   // const l3rnOnline = new Txt([
  //   //   new Txt("L").color("#494949").end,
  //   //   new Txt("3").bold().color('#0C8AAD').end,
  //   //   new Txt("RN online").color("#494949").end,
  //   // ]).absolutePosition(480,785).end;
  //   // pdf.add(l3rnOnline);

  //   return pdf;
  // }

  get userName() {
    if (!this.user) return "-";
    return this.user.fullName;
  }

  /**
   * Helper
   */

  formatDate(date) {
    if (date == null)
      return "-";

    return moment(date).format("DD.MM.yyyy");
  }
}
